import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Identifica',
    description: 'Localiza las 3 tareas que causan el 80% de vuestras discusiones usando nuestra matriz de energía dopaminérgica.'
  }, {
    number: '2',
    title: 'Visualiza',
    description: 'Instala los indicadores de semáforo y las listas de micro-pasos en puntos de paso físico obligatorio.'
  }, {
    number: '3',
    title: 'Comunica',
    description: 'Utiliza los guiones pre-escritos para separar el síntoma de la persona cuando el sistema falle (porque fallará) y evitar que el conflicto escale.'
  }];
  return <section className="py-16 md:py-24 bg-[#0f172a]" data-id="element-79">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-80">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-81">
          Cómo Funciona en 3 Pasos
        </h2>

        <div className="space-y-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-12 top-12 bottom-12 w-0.5 bg-slate-800" data-id="element-83"></div>

          {steps.map((step, index) => <div key={index} className="relative flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-84">
              <div className="flex-shrink-0 w-16 h-16 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-teal-500 to-teal-700 flex items-center justify-center shadow-lg shadow-teal-900/50 z-10 border-4 border-[#0f172a]" data-id="element-85">
                <span className="text-2xl md:text-4xl font-bold text-white" data-id="element-86">
                  {step.number}
                </span>
              </div>
              <div className="bg-slate-800/40 p-6 md:p-8 rounded-2xl border border-slate-700/50 flex-grow mt-2 md:mt-0" data-id="element-87">
                <h3 className="text-2xl font-bold text-amber-400 mb-3" data-id="element-88">
                  {step.title}
                </h3>
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-89">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}